import React, { useEffect, useRef } from "react";
import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import Login from "./components/pages/login";
import Dashboard from "./components/pages/dashboard";
import Employees from "./components/pages/employees";
import Profile from "./components/pages/profile";

import { store, persistor } from "./store";
import { Provider, useDispatch, useSelector } from "react-redux";

import Dashboard2 from "./components/pages/dashboard/Dashboard2";
import ProcessApp from "./components/pages/applications/in-process";
import AppInReview from "./components/pages/applications/app-in-review";
// import PendingApp from './components/pages/applications/pending';
import AppPending from "./components/pages/applications/appPending";
// import RejectedApp from './components/pages/applications/rejected';
import AppRejected from "./components/pages/applications/appRejected";
// import ApprovedApp from './components/pages/applications/approved';
import AppApproved from "./components/pages/applications/appApproved";
// import AppApproved from './components/pages/applications/approved';
import AppDiscrepancies from "./components/pages/applications/appDiscrepancies";
import AppRenewals from "./components/pages/applications/appRenewals";
import Feedback from "./components/pages/feedback";
import AppDraft from "./components/pages/applications/appDraft";
import AppCertifications from "./components/pages/appCertifications";
import FileCabinet from "./components/pages/file-cabinet";
import GamingLicence from "./components/pages/file-cabinet/gaming-licence";
import AppDashboard from "./components/pages/dashboard/aapDashboard";
import AppFormsAdmin from "./components/pages/appforms/appformAdmin";
// import AppFormCreation from './components/pages/formcreation';
import AppFormCreation from "./components/pages/formcreation/newIndex";
import Users from "./components/pages/users";
import { PersistGate } from "redux-persist/integration/react";
import AppProcessApp from "./components/pages/applications/app-in-process";
import AppViewApp from "./components/pages/applications/appViewApplication";
import AppEmployees from "./components/pages/appEmployees";
import AppUsers from "./components/pages/appUsers";
import LockedAccounts from "./components/pages/lockedAccounts";
import AppFeedback from "./components/pages/appFeedback";
import Categories from "./components/pages/categories";
import CreateCategories from "./components/pages/categories/create";
import EditCategories from "./components/pages/categories/edit";
import Companies from "./components/pages/companies";
import Notifications from "./components/pages/notifications";
import { fetchNotifications } from "./store/reducers/notificationSlice";
import DownloadApp from "./components/pages/applications/appDownload";
import Descrepancies from "./components/pages/applications/discrepancies";
import EmployeeDetails from "./components/pages/employeeDetails";
import CompanyDetails from "./components/pages/companyDetails";
import "react-phone-input-2/lib/style.css";
import { logoutUser, refreshToken } from "./store/reducers/authSlice";
import { hasRole, hasAnyRole, ROLES } from "./utility/rbac";
import Reset from "./components/pages/reset";
import SignUp from "./components/pages/signup";
import SignUp2 from "./components/pages/signup/SignUp2";
import Forget from "./components/pages/forget";

const MyRouter = () => {
  const hasRun = useRef(false);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const refreshTimeoutRef = useRef(null);
  useEffect(() => {
    if (user) {

      dispatch(fetchNotifications({ accessToken: user.access_token }));

    }
  }, []);

  useEffect(() => {


    console.log("runing refresh token setup");

    if (!user?.access_token || !user?.exp) return;

    // Clear previous timer
    if (refreshTimeoutRef.current) {
      clearTimeout(refreshTimeoutRef.current);
    }

    const expInMs = user.exp * 1000;
    const now = Date.now();

    // Refresh 15 seconds before expiry
    const refreshTime = expInMs - 15 * 1000;
    const delay = refreshTime - now;

    if (delay <= 0) {
      dispatch(refreshToken(user.access_token));
      return;
    }

    refreshTimeoutRef.current = setTimeout(() => {
      dispatch(refreshToken(user.access_token));
    }, delay);

    return () => {
      if (refreshTimeoutRef.current) {
        clearTimeout(refreshTimeoutRef.current);
      }
    };
  }, [user?.access_token, user?.exp, dispatch]);


  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/forget-password"
          element={user ? <Navigate to="/dashboard" replace /> : <Forget />}
        />
        <Route
          path="/edit-form/:id"
          element={hasRole(user, ROLES.ADMIN) ? <AppFormCreation /> : <Login />}
        />
        <Route
          path="/certifications"
          element={
            hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER, ROLES.VIEWER]) ? <AppCertifications /> : <Login />
          }
        />
        <Route
          path="/renewals"
          element={hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER, ROLES.VIEWER]) ? <AppRenewals /> : <Login />}
        />
        <Route
          path="/discrepancies"
          element={
            hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER]) ? <AppDiscrepancies /> : <Login />
          }
        />
        <Route
          path="/draft"
          element={hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER, ROLES.VIEWER]) ? <AppDraft /> : <Login />}
        />

        <Route
          path="/profile"
          element={user ? <Profile /> : <Login />}
        />
        {/* <Route path="/dashboard" element={user && user.user.is_admin? <Dashboard /> : <Login />} /> */}
        {/* <Route path="/forms" element={user && user.user.is_admin? <AppFormsAdmin /> : <Login />} /> */}
        <Route
          path="/forms/*"
          element={hasRole(user, ROLES.ADMIN) ? <AppFormsAdmin /> : <Login />}
        />
        <Route
          path="/dashboard"
          element={hasRole(user, ROLES.ADMIN) ? <AppDashboard /> : <Login />}
        />
        <Route
          path="/employees"
          element={hasRole(user, ROLES.ADMIN) ? <AppEmployees /> : <Login />}
        />
        <Route
          path="/employees/:id"
          element={hasRole(user, ROLES.ADMIN) ? <EmployeeDetails /> : <Login />}
        />
        {/* <Route path="/employees" element={user && user.user.is_admin? <Employees /> : <Login />} /> */}
        <Route
          path="/users"
          element={hasRole(user, ROLES.ADMIN) ? <AppUsers /> : <Login />}
        />
        <Route
          path="/locked-accounts"
          element={hasRole(user, ROLES.ADMIN) ? <LockedAccounts /> : <Login />}
        />
        {/* <Route path="/users" element={user && user.user.is_admin? <Users /> : <Login />} /> */}
        <Route
          path="/dashboard-2"
          element={hasRole(user, ROLES.ADMIN) ? <Dashboard2 /> : <Login />}
        />
        <Route
          path="/feedback"
          element={hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER]) ? <AppFeedback /> : <Login />}
        />
        {/* <Route path="/feedback" element={user && user.user.is_admin? <Feedback /> : <Login />} /> */}
        <Route
          path="/in-process-applications"
          element={hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER, ROLES.VIEWER]) ? <AppProcessApp /> : <Login />}
        />
        <Route
          path="/in-review"
          element={hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER]) ? <AppInReview /> : <Login />}
        />
        <Route
          path="/view-applications/:id"
          element={hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER, ROLES.VIEWER]) ? <AppViewApp /> : <Login />}
        />
        <Route
          path="/descrip-applications/:id"
          element={hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER]) ? <Descrepancies /> : <Login />}
        />

        {/* <Route path="/in-process-applications" element={user && user.user.is_admin? <ProcessApp /> : <Login />} /> */}
        <Route
          path="/pending-applications"
          element={hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER, ROLES.VIEWER]) ? <AppPending /> : <Login />}
        />
        <Route
          path="/rejected-applications"
          element={hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER, ROLES.VIEWER]) ? <AppRejected /> : <Login />}
        />
        <Route
          path="/approved-applications"
          element={hasAnyRole(user, [ROLES.ADMIN, ROLES.REVIEWER, ROLES.VIEWER]) ? <AppApproved /> : <Login />}
        />
        {/* <Route path="/discrepancies" element={user && user.user.is_admin? <Discrepancies /> : <Login />} /> */}
        {/* <Route path="/draft" element={user && user.user.is_admin? <Draft /> : <Login />} /> */}
        {/* <Route path="/renewals" element={user && user.user.is_admin? <Renewals /> : <Login />} /> */}
        {/* <Route path="/certifications" element={user && user.user.is_admin? <Certifications /> : <Login />} /> */}
        <Route
          path="/file-cabinet"
          element={hasRole(user, ROLES.ADMIN) ? <FileCabinet /> : <Login />}
        />
        <Route
          path="/gaming-licence"
          element={hasRole(user, ROLES.ADMIN) ? <GamingLicence /> : <Login />}
        />
        <Route
          path="/categories"
          element={hasRole(user, ROLES.ADMIN) ? <Categories /> : <Login />}
        />
        <Route
          path="/categories/create"
          element={
            hasRole(user, ROLES.ADMIN) ? <CreateCategories /> : <Login />
          }
        />
        <Route
          path="/categories/:id/edit"
          element={hasRole(user, ROLES.ADMIN) ? <EditCategories /> : <Login />}
        />
        <Route
          path="/companies"
          element={hasRole(user, ROLES.ADMIN) ? <Companies /> : <Login />}
        />
        <Route
          path="/companies/:id"
          element={hasRole(user, ROLES.ADMIN) ? <CompanyDetails /> : <Login />}
        />
        <Route path="/download-application" element={<DownloadApp />} />
        <Route
          path="/notification"
          element={hasRole(user, ROLES.ADMIN) ? <Notifications /> : <Login />}
        />
        <Route path="/reset-password" element={<Reset />} />
        <Route path="/signup-step1" element={<SignUp />} />
        <Route path="/signup-step2" element={<SignUp2 />} />
      </Routes>
    </Router>
  );
};

function App() {
  return (

    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MyRouter />
        <ToastContainer />
      </PersistGate>
    </Provider>

  );
}

export default App;
